import React from "react";
import { Link } from "react-router-dom";
import { MapPin, BedDouble, Bath, ArrowUpRight } from "lucide-react";
import { formatZAR } from "@/lib/api";
import { PROPERTY } from "@/lib/testIds";

export const PropertyCard = ({ property }) => {
  const isLeasing = property.listing_type === "leasing";

  return (
    <Link
      to={`/property/${property.id}`}
      data-testid={PROPERTY.card(property.id)}
      className="group block bg-card border border-border hover:border-primary transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-muted">
        <img
          src={property.images?.[0]}
          alt={property.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span className="overline text-[10px] bg-background/95 backdrop-blur px-2.5 py-1 rounded-sm">
            {isLeasing ? "For Lease" : "For Sale"}
          </span>
          {property.nsfas_accredited && (
            <span className="overline text-[10px] bg-secondary text-secondary-foreground px-2.5 py-1 rounded-sm">
              NSFAS
            </span>
          )}
        </div>
        <div className="absolute top-4 right-4 bg-background/95 backdrop-blur w-9 h-9 rounded-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h3 className="font-serif text-xl leading-tight truncate">{property.title}</h3>
            <p className="mt-1 text-sm text-muted-foreground flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5" />
              {property.city}
            </p>
          </div>
        </div>

        <div className="mt-5 flex items-end justify-between">
          <div>
            <p className="text-xs text-muted-foreground overline">
              {isLeasing ? "From" : "Asking"}
            </p>
            <p className="font-serif text-2xl mt-1">
              {formatZAR(property.price)}
              {isLeasing && <span className="text-sm text-muted-foreground font-sans"> /month</span>}
            </p>
          </div>
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1.5">
              <BedDouble className="w-3.5 h-3.5" />
              {property.bedrooms}
            </span>
            <span className="flex items-center gap-1.5">
              <Bath className="w-3.5 h-3.5" />
              {property.bathrooms}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};
